module.exports = __webpack_public_path__ + "media/assets/images/icons/flags/en-e2dd338d5fb71335e82aad5c0930cca9.svg";